export const calcProgressBar = ({
  currentStep,
  numberOfContractSteps
}: {
  currentStep: number;
  numberOfContractSteps: number;
}): number => {
  const stepsExcludingFinal = numberOfContractSteps - 1;
  const progressPerStep = 100 / stepsExcludingFinal;
  const currentProgress = currentStep * progressPerStep;
  return Math.round(currentProgress) / 100;
};
